<template id="modal-template">
  <transition name="modal">
    <div class="modal-mask px-2 sm:px-4 sidebar:px-6 fixed pin w-full h-full flex justify-between items-center" v-if="visible">
      <div class="modal-container mx-auto flex flex-col rounded bg-white w-full shadow-lg">
        <component :is="component"/>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';
import { HIDE_MODAL } from '@/store/mutations.types';

import store from '@/store';
import modal from '@/store/modules/modal';

if (!store.state.modal) store.registerModule('modal', modal);

export default {
  name: 'AppModal',
  data() {
    return {
      component: null
    };
  },
  computed: {
    ...mapState('modal', {
      visible: state => state.visible,
      modalComponent: state => state.component
    })
  },
  watch: {
    modalComponent(component) {
      if (!component) return;

      if (!Vue.options.components[component]) {
        Vue.component(component, () =>
          import(`@/components/modals/${component}`)
        );
      }

      this.component = component;
    }
  },
  methods: {
    ...mapMutations('modal', {
      hide: HIDE_MODAL
    })
  },
  created() {
    const escapeHandler = e => {
      if (e.keyCode == 27 && this.visible) {
        this.hide();
      }
    };

    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
    });
  }
};
</script>
